import { createActionRoute, createGlobalRoute } from '@townsquare/router/create-route';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const searchRedirectActionRoute: GlobalHomePageRoute = createGlobalRoute(
	createActionRoute({
		exact: true,
		name: 'searchAction',
		path: '/search/:entity',
	}),
);
